/** Colemak (standard, not DH): maps a physical code to the character that key emits. */
export const COLEMAK_CODE_TO_CHAR: Record<string, string> = {
  Backquote: "`",
  Digit1: "1",
  Digit2: "2",
  Digit3: "3",
  Digit4: "4",
  Digit5: "5",
  Digit6: "6",
  Digit7: "7",
  Digit8: "8",
  Digit9: "9",
  Digit0: "0",
  Minus: "-",
  Equal: "=",
  KeyQ: "Q",
  KeyW: "W",
  KeyE: "F",
  KeyR: "P",
  KeyT: "G",
  KeyY: "J",
  KeyU: "L",
  KeyI: "U",
  KeyO: "Y",
  KeyP: ";",
  BracketLeft: "[",
  BracketRight: "]",
  Backslash: "\\",
  KeyA: "A",
  KeyS: "R",
  KeyD: "S",
  KeyF: "T",
  KeyG: "D",
  KeyH: "H",
  KeyJ: "N",
  KeyK: "E",
  KeyL: "I",
  Semicolon: "O",
  Quote: "'",
  KeyZ: "Z",
  KeyX: "X",
  KeyC: "C",
  KeyV: "V",
  KeyB: "B",
  KeyN: "K",
  KeyM: "M",
  Comma: ",",
  Period: ".",
  Slash: "/",
};
